'use client';

import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["list", "children"];
import React from 'react';
import { ENCORE_DATA_IDS } from "../../dataEncoreIds.mjs";
import { cssColorValue, semanticColors } from "../../styles/index.mjs";
import styled from "../../styled-components.mjs";
var NavBarPage = styled.div.withConfig({
  displayName: "NavBar__NavBarPage",
  componentId: "sc-1guraqe-0"
})(["color:", ";overflow-wrap:break-word;"], cssColorValue(semanticColors.textBase));
/**
 * @deprecated
 * This component will be archived soon.
 * Please use the Tabs component instead.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-navbar--docs) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/NavBar) |
 * [Figma](https://www.figma.com/design/bnQXqGkLeiTlbk8JXGDcsX/%E2%9A%99%EF%B8%8F-%E2%80%8A%E2%80%8BEncore-Web-Components?m=auto&node-id=32403-12653&t=X3Pv9ZLvoMIaXVBJ-1)
 **/
export var NavBar = function NavBar(_ref) {
  var list = _ref.list,
    children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("section", Object.assign({}, props, {
    "data-encore-id": ENCORE_DATA_IDS.NavBar
  }), list, /*#__PURE__*/React.createElement(NavBarPage, null, children));
};